import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";

import Style from "@client/utils/Style";

import filterImage from "./images/filter";
import searchImage from "./images/search";

const Wrapper = styled.div`
  display: inline-block;
`;
const Icon = styled.div`
  width: 16px;
  height: 16px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

type Props = {
  className?: string;
  primary?: boolean;
  useFilterIcon?: boolean;
  onClick?: () => void;
};
@observer
class SearchButton extends React.Component<Props> {
  render() {
    return (
      <Wrapper className={this.props.className} {...this.props}>
        <Icon
          dangerouslySetInnerHTML={{
            __html: this.props.useFilterIcon
              ? filterImage(Style.palette.grayscale[3])
              : searchImage(
                  this.props.primary
                    ? Style.palette.primary
                    : Style.palette.grayscale[4],
                ),
          }}
        />
      </Wrapper>
    );
  }
}

export default SearchButton;
